import React from "react";
import { useNavigate } from "react-router-dom";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";

const HeaderTab = (p) => {
  return (
    <div className="header-tab-leaderboard">
      <div className="tab-wrapper" onClick={() => p.setActiveTab("points")}>
        <img
          src={Assets.iconGoldCoin}
          alt="logo_image"
          className={`tab-img ${p.activeTab == "points" ? "" : "inactive"}`}
        />
        <span
          className={`tab-text ${p.activeTab == "points" ? "" : "inactive"}`}
        >
          Points
        </span>
      </div>
      <div className="tab-wrapper" onClick={() => p.setActiveTab("stars")}>
        <img
          src={Assets.iconStar}
          alt="logo_image"
          className={`tab-img ${p.activeTab == "points" ? "inactive" : ""}`}
        />
        <span
          className={`tab-text ${p.activeTab == "points" ? "inactive" : ""}`}
        >
          Stars
        </span>
      </div>
    </div>
  );
};

export default HeaderTab;
